import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import PriceCheckIcon from '@mui/icons-material/PriceCheck'
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuList,
  Stack
  // TextField
} from '@mui/material'
import Avatar from '@mui/material/Avatar'
import Pagination from '@mui/material/Pagination'
import { useQuery } from '@tanstack/react-query'
import PaymentAPI from 'api/faber/PaymentAPI'
// import DateRangePicker from 'common/AbstractDateRangePicker/AbstractDateRangePicker'
// import CustomSearchbarFilter from 'common/AbstractDropdown/CustomSearchbarFilter'
import ColorBox from 'common/Box/ColorWhiteBox'
import NormalText from 'common/Typography/NormalText'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
// import { isWithinInterval } from 'date-fns'
import format from 'date-fns/format'
import OrbitSession from 'hooks/useCookies'
// import { changeMonth } from 'helpers/date'
import useModal from 'hooks/useModal'
import { TransformedFaberUserData } from 'types/api/faber/globalCustomers.type'
import { GetCustomerPaymentTransaction } from 'types/api/faber/payment.type'

import { RefundFormV2Dialog, ResendReceiptDialog } from '../sharedDialogs'

// import FilterTransactionBtn from './FilterTransactionBtn'
// TO DO: Remove when not necessary
// import PaymentDetailV2 from './PaymentDetailV2'
import NoPermissionSnackbar from './NoPermissionSnackbar'

// TO DO: to show payment transaction type- for subscription or one time product

const StyledHeaderText = styled(NormalText)({
  fontSize: '0.8em',
  color: '#818D9C',
  fontWeight: 700
})

const StyledBodyText = styled(NormalText)({
  fontSize: '0.65em'
})

interface TransactionActionMenuProps {
  tx: GetCustomerPaymentTransaction
  customerRow: TransformedFaberUserData
  setTransactionData: React.Dispatch<
    React.SetStateAction<GetCustomerPaymentTransaction | undefined>
  >
  handleReceiptDialogOpen: () => void
  handleRefundDialogOpen: () => void
  showRefund: boolean
}

const TransactionActionMenu = ({
  tx,
  setTransactionData,
  handleReceiptDialogOpen,
  handleRefundDialogOpen,
  showRefund
}: TransactionActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        sx={{
          borderRadius: '20%',
          px: 2,
          backgroundColor: circlesOrbitColorPalette.toolkit.main,
          boxShadow: 3,
          '&:hover': {
            backgroundColor: '#dcddf1'
          },
          '&:disabled': {
            backgroundColor: circlesOrbitColorPalette.neutrals[200]
          }
        }}
        onClick={(e) => {
          handleMenuClick(e)
          setTransactionData(tx)
        }}
      >
        <MoreHorizIcon />
      </IconButton>

      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuList>
          {showRefund && (
            <MenuItem
              onClick={() => {
                handleRefundDialogOpen()
              }}
            >
              <ListItemIcon>
                <PriceCheckIcon />
              </ListItemIcon>
              <TextColorFontBody>Refund</TextColorFontBody>
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              handleReceiptDialogOpen()
            }}
          >
            <ListItemIcon>
              <ForwardToInboxIcon />
            </ListItemIcon>
            <TextColorFontBody>
              Send {tx?.paymentStatus === 'REFUNDED' && 'Refund '}
              Receipt
            </TextColorFontBody>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  )
}

function ExternalPaymentLogsV2({ customerId, customerRow }: PaymentLogsProps) {
  const [receiptDialogOpen, setReceiptDialogOpen] = useState(false)
  const vendor = OrbitSession.get('vendor')

  const handleReceiptDialogOpen = () => {
    setReceiptDialogOpen(true)
  }

  const handleReceiptDialogClose = () => {
    setReceiptDialogOpen(false)
  }

  const {
    openModal: openRefundDialog,
    closeModal: closeRefundDialog,
    isShowing: isRefundDialogShowing
  } = useModal()

  /*FOR PAGINATION */
  const [count, setCount] = useState(0)
  const [pageSize] = useState(5)
  const [currentPage, setCurrentPage] = useState(1)
  // const [lowerLimit, setLowerLimit] = useState((currentPage - 1) * pageSize)
  // const [upperLimit, setUpperLimit] = useState(currentPage * pageSize)
  /*FOR FILTERS AND SEARCH */
  // set start date to before faber launch
  // const [startDate, setStartDate] = useState<Date>(new Date(2022, 9, 1))
  // const [endDate, setEndDate] = useState<Date>(changeMonth(new Date(), +3))
  // const [isSearchFilteredOn, setIsSearchFilteredOn] = useState(false)
  // const [isFilteredOn, setIsFilteredOn] = useState(false)
  const [filteredData, setFilteredData] = useState<
    GetCustomerPaymentTransaction[]
  >([])
  // TO DO: WHEN FILTER BY PAYMENT STATUS IS UP
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [filteredValue, setFilteredValue] = useState('')
  // const [searchOption, setSearchOption] = useState('Date Range')
  // const [textValue, setTextValue] = useState('')

  /*STATE OF DATA RETRIEVED */
  const [transactionData, setTransactionData] =
    useState<GetCustomerPaymentTransaction>()

  /* MEMOIZED HELPER FUNCTIONS */
  // const checkIsDateWithin = useCallback(
  //   (updatedDate: string) => {
  //     return isWithinInterval(new Date(updatedDate), {
  //       start: new Date(startDate),
  //       end: new Date(endDate)
  //     })
  //   },
  //   [startDate, endDate]
  // )
  /*EVENT HANDLERS */

  const {
    isShowing: permissionSnackbarOpen,
    // openModal: handlePermissionSnackbarOpen,
    closeModal: handlePermissionSnackbarClose
  } = useModal()

  //pagination handling
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value)
  }

  // TODO: fix filters
  //filters handling
  // const handleFilterSelection = (value: string) => {
  //   setIsFilteredOn(true)
  //   setFilteredValue(value)
  // }
  // const handleClearFilterSelection = () => {
  //   setIsFilteredOn(false)
  //   setFilteredValue('')
  // }
  // //search handling
  // const handleSelectOption = (_, v) => {
  //   setSearchOption(v)
  // }

  // const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setTextValue(e.target.value.trim())
  //   if (e.target.value === '') {
  //     setIsSearchFilteredOn(false)
  //     setFilteredData(customerTxData?.data.body.data ?? [])
  //   } else {
  //     setIsSearchFilteredOn(true)
  //   }
  // }
  // const onDateChange = () => {
  //   setIsSearchFilteredOn(true)
  // }
  /*API REQUEST */
  const {
    data: customerTxData,
    isLoading: isCustomerTransactionLoading,
    refetch: refetchPaymentLogs
  } = useQuery(
    [
      'getIndividualCustomerTransaction',
      [customerRow.countryCode, customerId, pageSize]
    ],
    async () => {
      if (customerRow.countryCode === '+65') {
        return PaymentAPI.getCustomerTransactions({
          customerId: customerId ? customerId : '',
          offset: currentPage - 1,
          limit: pageSize,
          order: 'desc'
        })
      } else {
        return PaymentAPI.getGlobalCustomerTransactions({
          customerId: customerId ? customerId : '',
          offset: currentPage - 1,
          limit: pageSize,
          order: 'desc'
        })
      }
    },
    {
      onSuccess: (res) => {
        setCount(Math.ceil(res.data.body.total / pageSize))
        setFilteredData(res.data.body.data)
      }
    }
  )

  useEffect(() => {
    refetchPaymentLogs()
  }, [currentPage])

  /*SIDE EFFECTS*/
  // useEffect(() => {
  //   refetchPaymentLogs()
  // }, [isRefundDialogShowing])

  return (
    <>
      {isCustomerTransactionLoading || !customerTxData ? (
        <CircularProgress />
      ) : (
        <Box sx={{ display: 'flex', gap: 2 }}>
          <ColorBox
            sx={{
              width: '100%',
              minHeight: '80vh',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              minWidth: '800px'
            }}
          >
            <>
              <Box sx={{ height: '90%' }}>
                {/* <Stack direction='row' justifyContent='space-between'>
                  <FilterTransactionBtn
                    handleFilterSelection={handleFilterSelection}
                    handleClearFilterSelection={handleClearFilterSelection}
                  />
                  <Box>
                    <CustomSearchbarFilter
                      defaultValue={'Date Range'}
                      handleChange={handleSelectOption}
                      options={['Date Range', 'Transaction Number']}
                    >
                      {searchOption === 'Date Range' ? (
                        <DateRangePicker
                          startDate={startDate}
                          setStartDate={setStartDate}
                          endDate={endDate}
                          setEndDate={setEndDate}
                          onDateChange={onDateChange}
                        />
                      ) : (
                        <TextField
                          size='small'
                          label={`Search by ${searchOption}`}
                          sx={{ width: '15vw' }}
                          onChange={handleTextChange}
                        />
                      )}
                    </CustomSearchbarFilter>
                  </Box>
                </Stack> */}
                {filteredData.map((tx, index) => (
                  <React.Fragment key={tx.trn + index}>
                    <Card
                      sx={{
                        mb: 3,
                        border: '1px solid #ECEFF4',
                        boxShadow: 'none'
                      }}
                    >
                      <CardContent
                        sx={{
                          display: 'flex',
                          pb: 0,
                          p: 2
                        }}
                      >
                        <Box
                          pr={2}
                          sx={{ display: 'flex', alignItems: 'center' }}
                        >
                          <Avatar
                            sx={{
                              p: 2,
                              bgcolor: `${
                                tx.paymentStatus === 'FAILED'
                                  ? '#cc005a'
                                  : tx.paymentStatus === 'REFUNDED'
                                  ? '#CC0C00'
                                  : '#00C0CC'
                              }`,
                              fontSize: '0.8em',
                              textAlign: 'center',
                              mb: 1
                            }}
                          >
                            {tx.paymentStatus.toUpperCase()}
                          </Avatar>
                        </Box>

                        <Grid container>
                          <Grid item xs={2}>
                            <Stack>
                              <StyledHeaderText>
                                Payment Reference ID
                              </StyledHeaderText>
                              {customerId == tx.paidFor ? (
                                <StyledBodyText>
                                  <b>Paid by</b> {tx.userId}
                                </StyledBodyText>
                              ) : (
                                <StyledBodyText>{tx.trn}</StyledBodyText>
                              )}
                            </Stack>
                          </Grid>
                          <Grid item xs={2}>
                            <Stack>
                              <StyledHeaderText>Amount</StyledHeaderText>
                              <StyledBodyText>{`$ ${tx.amount.toString()}`}</StyledBodyText>
                            </Stack>
                          </Grid>
                          <Grid item xs={2}>
                            <Stack>
                              <StyledHeaderText>Payment Type</StyledHeaderText>
                              <StyledBodyText>{tx.paymentType}</StyledBodyText>
                            </Stack>
                          </Grid>
                          <Grid item xs={2}>
                            <Stack>
                              <StyledHeaderText>Updated by</StyledHeaderText>
                              <StyledBodyText>{tx.updatedBy}</StyledBodyText>
                            </Stack>
                          </Grid>
                          <Grid item xs={2}>
                            <Stack>
                              <StyledHeaderText>
                                Created at, Updated at
                              </StyledHeaderText>
                              <StyledBodyText>
                                {format(
                                  new Date(tx.created),
                                  'dd MMM yyyy HH:mm'
                                )}
                              </StyledBodyText>
                              <StyledBodyText>
                                {format(
                                  new Date(tx.updated),
                                  'dd MMM yyyy HH:mm'
                                )}
                              </StyledBodyText>
                            </Stack>
                          </Grid>

                          <Grid item xs={2}>
                            <Stack>
                              <StyledHeaderText>More actions</StyledHeaderText>
                              <Box>
                                <TransactionActionMenu
                                  tx={tx}
                                  customerRow={customerRow}
                                  setTransactionData={setTransactionData}
                                  handleReceiptDialogOpen={
                                    handleReceiptDialogOpen
                                  }
                                  handleRefundDialogOpen={openRefundDialog}
                                  showRefund={
                                    vendor.toLowerCase() === 'mobicom'
                                  }
                                />
                              </Box>
                            </Stack>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </React.Fragment>
                ))}
              </Box>
              <Box sx={{ mt: 5 }}>
                <Pagination
                  hidePrevButton
                  count={count}
                  color='primary'
                  page={currentPage}
                  onChange={handlePageChange}
                />
              </Box>
            </>
          </ColorBox>
          <NoPermissionSnackbar
            handlePermissionSnackbarClose={handlePermissionSnackbarClose}
            permissionSnackbarOpen={permissionSnackbarOpen}
          />
          <RefundFormV2Dialog
            handleDialogClose={closeRefundDialog}
            dialogOpen={isRefundDialogShowing}
            paymentId={transactionData?.trn ? transactionData.trn : ''}
            refetchPaymentLogs={refetchPaymentLogs}
            iccid={customerRow.iccid ? customerRow.iccid : ''}
            userId={customerRow.userID}
            email={customerRow.userEmail ? customerRow.userEmail : ''}
            transactionType={
              transactionData?.paymentType ? transactionData.paymentType : ''
            }
            isExternalUser={vendor.toLowerCase() === 'mobicom'}
          />

          <ResendReceiptDialog
            receiptDialogOpen={receiptDialogOpen}
            handleDialogClose={handleReceiptDialogClose}
            transanctionNo={transactionData?.trn ? transactionData.trn : ''}
            email={customerRow.userEmail ? customerRow.userEmail : ''}
            userId={customerRow.userID}
            transactionType={
              transactionData?.paymentType ? transactionData.paymentType : ''
            }
            isExternal={true}
            paymentIntent={''}
          />
        </Box>
      )}
    </>
  )
}

export default ExternalPaymentLogsV2

interface PaymentLogsProps {
  customerId: string | undefined
  customerRow: TransformedFaberUserData
  handleRefundRequestTabChange: () => void
}
